import { Routes } from '@angular/router';

// HOME + STATIC
import { HomeComponent } from '../app/pages/home/home';
import { BlogComponent } from '../app/pages/blog/blog';
import { Privacy } from '../app/pages/privacy/privacy';
import { PreventivoPageComponent } from '../app/pages/preventivo/preventivo';
import { AiComponent } from './pages/ai/ai.component';
import { LavoraConNoiComponent } from '../app/pages/lavora-con-noi/lavora-con-noi';
import { CollaboratoriComponent } from '../app/pages/collaboratori/collaboratori';

// SERVIZI
import { SanificazioniComponent } from '../app/pages/sanificazioni/sanificazioni';
import { UfficiComponent } from '../app/pages/uffici/uffici';
import { CondominiComponent } from '../app/pages/condomini/condomini';
import { PalestraComponent } from '../app/pages/palestra/palestra';
import { DomesticaComponent } from '../app/pages/domestica/domestica';
import { StraordinariaComponent } from '../app/pages/straordinaria/straordinaria';
import { CucineIndustrialiComponent } from '../app/pages/pastificio/pastificio';
import { LaboratoriAlimentariComponent } from '../app/pages/panificio/panificio';
import { BlogArticoloPulizieAppartamentoComponent } from '../app/pages/blog-articolo-1/blog-articolo-pulizie-appartamento';
import { BlogDifferenzaPulizieOrdinarieStraordinarieComponent } from '../app/pages/blog-articolo-2/blog-differenza-pulizie-ordinarie-straordinarie';
import { BlogSanificazioniVsIgienizzazioniComponent } from '../app/pages/blog-articolo-3/blog-sanificazioni-vs-igienizzazioni';
import { BlogImpresaPulizieComponent } from '../app/pages/blog-articolo-4/cosa-valutare-impresa-di-pulizie';
import { Blog5ConsigliCasaComponent } from '../app/pages/blog-articolo-5/5-consigli-casa-sempre-pulita';
import { BlogProdottiNaturaliComponent } from '../app/pages/blog-articolo-6/pulire-casa-prodotti-naturali';
import { NotFoundComponent } from '../app/pages/not-found/not-found';
import { GiulianovaTeramoComponent } from './pages/giulianova-teramo/giulianova-teramo';

const OG_DEFAULT = '/assets/pullizia-uffici-postazione.webp';

export const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    data: {
      seo: {
        title: 'SAMI Pulizie | Impresa di pulizie a Pescara, Giulianova e Teramo',
        description: 'Pulizie professionali a Pescara. Da settembre 2026 operativi anche a Giulianova, Teramo e provincia per uffici, condomini, attività e privati.',
        canonicalUrl: '/',
        ogImage: OG_DEFAULT,
        ogImageWidth: '1200',
        ogImageHeight: '630',
        twitterImageAlt: 'SAMI Pulizie - Impresa di pulizie a Pescara, Giulianova e Teramo'
      }
    }
  },

  {
    path: 'impresa-pulizie-giulianova-teramo',
    component: GiulianovaTeramoComponent,
    data: {
      seo: {
        title: 'Impresa di pulizie Giulianova e Teramo | SAMI Pulizie',
        description: 'Impresa di pulizie a Giulianova, Teramo e provincia. Da settembre 2026 pulizia condomini, uffici, attività, palestre e sanificazioni.',
        canonicalUrl: '/impresa-pulizie-giulianova-teramo',
        ogImage: OG_DEFAULT,
        ogImageWidth: '1200',
        ogImageHeight: '630'
      }
    }
  },

  // STATICHE
  {
    path: 'blog',
    component: BlogComponent,
    data: {
      seo: {
        title: 'Blog | SAMI Pulizie',
        description: 'Consigli e guide sulla pulizia professionale: uffici, condomini, sanificazioni e pulizie domestiche a Pescara e provincia.',
        canonicalUrl: '/blog',
        ogImage: OG_DEFAULT,
        ogImageWidth: '1200',
        ogImageHeight: '630'
      }
    }
  },
  {
    path: 'privacy',
    component: Privacy,
    data: {
      seo: {
        title: 'Privacy Policy | SAMI Pulizie',
        description: 'Informativa Privacy di SAMI Pulizie. Trattamento dati, contatti e diritti dell’interessato.',
        canonicalUrl: '/privacy',
        ogImage: OG_DEFAULT
      }
    }
  },
  {
    path: 'preventivo',
    component: PreventivoPageComponent,
    data: {
      seo: {
        title: 'Richiedi un preventivo | SAMI Pulizie',
        description: 'Richiedi un preventivo per pulizie professionali: uffici, condomini, palestre, sanificazioni e pulizie domestiche a Pescara e provincia.',
        canonicalUrl: '/preventivo',
        ogImage: OG_DEFAULT
      }
    }
  },
{
  path: 'lavora-con-noi',
  component: LavoraConNoiComponent,
  data: {
    seo: {
      title: 'Lavora con noi | SAMI Pulizie',
      description: 'Entra nel team SAMI Pulizie. Invia la tua candidatura per lavori di pulizia a Pescara e provincia.',
      canonicalUrl: '/lavora-con-noi',
      ogImage: OG_DEFAULT,
      ogImageWidth: '1200',
      ogImageHeight: '630'
    }
  }
},
{
  path: 'collaboratori',
  component: CollaboratoriComponent,
  data: {
    seo: {
      title: 'I nostri migliori Collaboratori | SAMI Pulizie',
      description: 'Scopri i partner e collaboratori di SAMI Pulizie a Pescara. Aziende e professionisti che lavorano con noi per offrire servizi di pulizia di qualità.',
      canonicalUrl: '/collaboratori',
      ogImage: OG_DEFAULT,
      ogImageWidth: '1200',
      ogImageHeight: '630'
    }
  }
},
  // opzionale: io la metterei noindex perché non è una pagina “pubblica”
  {
    path: 'ai',
    component: AiComponent,
    data: {
      seo: {
        title: 'Area AI | SAMI Pulizie',
        description: 'Area interna SAMI Pulizie.',
        canonicalUrl: '/ai',
        robots: 'noindex,nofollow'
      }
    }
  },

  // SERVIZI
  {
    path: 'sanificazioni',
    component: SanificazioniComponent,
    data: {
      seo: {
        title: 'Sanificazioni a Pescara | SAMI Pulizie',
        description: 'Sanificazioni professionali per ambienti di lavoro e spazi comuni a Pescara e provincia. Interventi su misura e personale qualificato.',
        canonicalUrl: '/sanificazioni',
        ogImage: OG_DEFAULT
      }
    }
  },
  {
    path: 'uffici',
    component: UfficiComponent,
    data: {
      seo: {
        title: 'Pulizia uffici a Pescara | SAMI Pulizie',
        description: 'Pulizia uffici privati e pubblici a Pescara e provincia. Piani personalizzati, qualità garantita e preventivo rapido.',
        canonicalUrl: '/uffici',
        ogImage: OG_DEFAULT
      }
    }
  },
  {
    path: 'condomini',
    component: CondominiComponent,
    data: {
      seo: {
        title: 'Pulizia condomini a Pescara | SAMI Pulizie',
        description: 'Pulizia scale, androni e aree comuni condominiali a Pescara e provincia. Affidabilità, puntualità e interventi programmati.',
        canonicalUrl: '/condomini',
        ogImage: OG_DEFAULT
      }
    }
  },
  {
    path: 'palestra',
    component: PalestraComponent,
    data: {
      seo: {
        title: 'Pulizia palestre a Pescara | SAMI Pulizie',
        description: 'Pulizia e igienizzazione palestre e centri sportivi a Pescara e provincia. Ambienti sicuri per clienti e staff.',
        canonicalUrl: '/palestra',
        ogImage: OG_DEFAULT
      }
    }
  },
  {
    path: 'domestica',
    component: DomesticaComponent,
    data: {
      seo: {
        title: 'Pulizie domestiche a Pescara | SAMI Pulizie',
        description: 'Pulizie domestiche a Pescara e provincia: case, appartamenti e ville. Interventi regolari o straordinari su richiesta.',
        canonicalUrl: '/domestica',
        ogImage: OG_DEFAULT
      }
    }
  },
  {
    path: 'straordinaria',
    component: StraordinariaComponent,
    data: {
      seo: {
        title: 'Pulizie straordinarie a Pescara | SAMI Pulizie',
        description: 'Pulizie straordinarie a Pescara e provincia: post ristrutturazione, fine cantiere, pulizie profonde e interventi urgenti.',
        canonicalUrl: '/straordinaria',
        ogImage: OG_DEFAULT
      }
    }
  },
 {
  path: 'cucine-industriali',
  component: CucineIndustrialiComponent,
  data: {
    seo: {
      title: 'Pulizia cucine industriali a Pescara | SAMI Pulizie',
      description: 'Pulizia professionale cucine industriali, ristoranti e mense a Pescara e provincia.',
      canonicalUrl: '/cucine-industriali',
      ogImage: OG_DEFAULT
    }
  }
},
{
  path: 'laboratori-alimentari',
  component: LaboratoriAlimentariComponent,
  data: {
    seo: {
      title: 'Pulizia laboratori alimentari a Pescara | SAMI Pulizie',
      description:
        'Pulizia e sanificazione professionale per laboratori alimentari, panifici e pastifici a Pescara e provincia. Servizi conformi HACCP e controlli ASL.',
      canonicalUrl: '/laboratori-alimentari',
      ogImage: OG_DEFAULT,
      ogImageWidth: '1200',
      ogImageHeight: '630'
    }
  }
},
{
  path: 'blog/quanto-costano-pulizie-appartamento-pescara',
  component: BlogArticoloPulizieAppartamentoComponent,
  data: {
    seo: {
      title: 'Quanto costano le pulizie appartamento a Pescara? | SAMI Pulizie',
      description: 'Scopri i prezzi delle pulizie per appartamento a Pescara e provincia. Tariffe indicative, fattori che influenzano il costo e come richiedere un preventivo gratuito.',
      canonicalUrl: '/blog/quanto-costano-pulizie-appartamento-pescara',
      ogImage: OG_DEFAULT,
      ogImageWidth: '1200',
      ogImageHeight: '630'
    }
  }
},
{
  path: 'blog/differenza-pulizie-ordinarie-straordinarie',
  component: BlogDifferenzaPulizieOrdinarieStraordinarieComponent,
  data: {
    seo: {
      title: 'Differenza tra pulizie ordinarie e straordinarie | SAMI Pulizie',
      description: 'Cosa distingue le pulizie ordinarie da quelle straordinarie? Scopri quando scegliere l\'una o l\'altra e come organizzare la pulizia della tua abitazione o ufficio.',
      canonicalUrl: '/blog/differenza-pulizie-ordinarie-straordinarie',
      ogImage: OG_DEFAULT,
      ogImageWidth: '1200',
      ogImageHeight: '630'
    }
  }
},
{
  path: 'blog/sanificazioni-vs-igienizzazioni-cosa-cambia',
  component: BlogSanificazioniVsIgienizzazioniComponent,
  data: {
    seo: {
      title: 'Sanificazioni vs Igienizzazioni: cosa cambia? | SAMI Pulizie',
      description: 'Sanificazione o igienizzazione? Scopri le differenze, quando è necessaria una sanificazione professionale e perché è fondamentale per uffici e ambienti di lavoro.',
      canonicalUrl: '/blog/sanificazioni-vs-igienizzazioni-cosa-cambia',
      ogImage: OG_DEFAULT,
      ogImageWidth: '1200',
      ogImageHeight: '630'
    }
  }
},
{
  path: 'blog/cosa-valutare-impresa-di-pulizie',
  component: BlogImpresaPulizieComponent,
  data: {
    seo: {
      title: 'Cosa valutare prima di scegliere un\'impresa di pulizie | SAMI Pulizie',
      description: 'Guida pratica su come scegliere la giusta impresa di pulizie: certificazioni, referenze, prezzi trasparenti e affidabilità. Tutto quello che devi sapere.',
      canonicalUrl: '/blog/cosa-valutare-impresa-di-pulizie',
      ogImage: OG_DEFAULT,
      ogImageWidth: '1200',
      ogImageHeight: '630'
    }
  }
},
{
  path: 'blog/5-consigli-casa-sempre-pulita',
  component: Blog5ConsigliCasaComponent,
  data: {
    seo: {
      title: '5 consigli per tenere la casa sempre pulita | SAMI Pulizie',
      description: 'Cinque consigli pratici per mantenere la tua casa sempre in ordine e pulita. Routine efficaci, prodotti giusti e quando affidarsi a professionisti.',
      canonicalUrl: '/blog/5-consigli-casa-sempre-pulita',
      ogImage: OG_DEFAULT,
      ogImageWidth: '1200',
      ogImageHeight: '630'
    }
  }
},
{
  path: 'blog/pulire-casa-prodotti-naturali',
  component: BlogProdottiNaturaliComponent,
  data: {
    seo: {
      title: 'Pulire casa con prodotti naturali: guida completa | SAMI Pulizie',
      description: 'Come pulire casa in modo ecologico usando prodotti naturali come aceto, bicarbonato e limone. Metodi efficaci, sicuri e rispettosi dell\'ambiente.',
      canonicalUrl: '/blog/pulire-casa-prodotti-naturali',
      ogImage: OG_DEFAULT,
      ogImageWidth: '1200',
      ogImageHeight: '630'
    }
  }
},
  // REDIRECT pagine vecchie/errate → pagine corrette
  { path: 'panificio', redirectTo: '/laboratori-alimentari', pathMatch: 'full' },
  { path: 'pastificio', redirectTo: '/cucine-industriali', pathMatch: 'full' },
  { path: 'pulizie-laboratori-alimentari', redirectTo: '/laboratori-alimentari', pathMatch: 'full' },
  // NOT FOUND
  {
    path: '**',
    component: NotFoundComponent,
    data: {
      seo: {
        title: '404 - Pagina non trovata | SAMI Pulizie',
        description: 'Ops! La pagina che cerchi non esiste. Torna alla home di SAMI Pulizie.',
        canonicalUrl: '/404',
        robots: 'noindex,nofollow'
      }
    }
  }
];
